import { createSlice } from '@reduxjs/toolkit';
import { remove } from 'lodash';
import { UiState } from 'constants/ui';
import { stateName, FieldName } from './constants';
const initialFormState = {
  isFormDisabled: false,
  uiState: UiState.Idle,
  isFormDirty: false,
  hasUnknownApiErrorOccured: false
};
const initialFormData = {
  firstName: null,
  lastName: null,
  birthdate: null,
  ssnSerial: null,
  personalIdNumber: null,
  address: null,
  ubos: null,
  isLegalRepresentativeUbo: true,
  documents: []
};
const initialState = {
  formData: initialFormData,
  generalErrors: {
    byName: {},
    names: []
  },
  apiErrors: [],
  paymentsIdentityConfiguration: null,
  formState: initialFormState
};

const setFormIsDirty = draft => {
  draft.formState.isFormDirty = true;
};

function deleteGeneralError(draft, fieldName) {
  if (fieldName in draft.generalErrors.byName) {
    delete draft.generalErrors.byName[fieldName];
  }

  remove(draft.generalErrors.names, name => name === fieldName);
}

const setIsFormDisabled = (draft, action) => {
  const {
    isFormDisabled
  } = action.payload;
  draft.formState.isFormDisabled = isFormDisabled;
};

const setHasUnknownApiErrorOccured = (draft, action) => {
  const {
    status
  } = action.payload;
  draft.formState.hasUnknownApiErrorOccured = status;
};

const setConfiguration = (draft, action) => {
  const {
    configuration
  } = action.payload;
  draft.paymentsIdentityConfiguration = configuration;
  draft.formData = {
    firstName: configuration.firstName,
    lastName: configuration.lastName,
    birthdate: configuration.birthdate,
    address: configuration.address,
    ubos: null,
    isLegalRepresentativeUbo: draft.formData.isLegalRepresentativeUbo,
    documents: []
  };
  draft.formState.isFormDirty = false;
  draft.formState.uiState = UiState.Success;
};

const submitFormRequest = draft => {
  draft.formState.uiState = UiState.Pending;
};

const submitFormSuccess = draft => {
  draft.formState.uiState = UiState.Success;
  draft.formState.isFormDisabled = false;
};

const setFormData = (draft, action) => {
  const {
    firstName,
    lastName,
    birthdate,
    ssnSerial,
    personalIdNumber,
    ubos,
    documents
  } = action.payload;
  draft.formData.firstName = firstName;
  draft.formData.lastName = lastName;
  draft.formData.birthdate = birthdate;
  draft.formData.ssnSerial = ssnSerial;
  draft.formData.personalIdNumber = personalIdNumber;
  draft.formData.ubos = ubos;
  draft.formData.documents = documents;
  draft.formState.isFormDirty = true;
};

const setGeneralErrors = (draft, action) => {
  const {
    errors
  } = action.payload;
  errors.forEach(error => {
    draft.generalErrors.byName[error.field] = error.value;
  });
  draft.generalErrors.names = errors.map(error => error.field);
  draft.apiErrors = errors;
};

const setAddress = (draft, action) => {
  if (!draft.paymentsIdentityConfiguration) return;
  const {
    address
  } = action.payload;
  draft.formData.address = address;
  draft.formState.isFormDirty = true;
  deleteGeneralError(draft, FieldName.Address);
};

const setIsLegalRepresentativeUbo = (draft, action) => {
  const {
    isLegalRepresentativeUbo
  } = action.payload;
  draft.formData.isLegalRepresentativeUbo = isLegalRepresentativeUbo;
};

const paymentsIdentitySlice = createSlice({
  name: stateName,
  initialState,
  reducers: {
    setIsFormDisabled,
    setHasUnknownApiErrorOccured,
    setConfiguration,
    submitFormRequest,
    submitFormSuccess,
    setFormData,
    setGeneralErrors,
    setAddress,
    setIsLegalRepresentativeUbo,
    setFormIsDirty
  }
});
export const {
  actions
} = paymentsIdentitySlice;
export const plug = {
  [stateName]: paymentsIdentitySlice.reducer
};
export default paymentsIdentitySlice.reducer;